export default {
  对外显示: '对外显示',
  推荐的产品: '推荐的产品',
  推荐内容修改: '推荐内容修改',
  我的名片提示7: '群组内数据还可以在“全部”分组中查看',
  我的名片提示6: '是否删除当前群组？',
  我的名片提示5: '创建个人云展,洽谈快人一步',
  微信扫一扫预览: '微信扫一扫预览',
  得分: '得分',
  立即创建: '立即创建',
  更多样式选择: '更多样式选择',
  请前往: '请前往',
  我的名片: '我的名片',
  取消编辑: '取消编辑',
  移动到分组: '移动到分组',
  删除分组: '删除分组',
  编辑分组: '编辑分组',
  添加分组: '添加分组',
  最多输入100个字符: '最多输入100个字符',
  '请输入个人标签,回车确定': '请输入个人标签,回车确定',
  最多输入30个字符: '最多输入30个字符',
  '请输入邮箱,回车确定': '请输入邮箱,回车确定',
  固定电话不能为空: '固定电话不能为空',
  我的名片提示4: '请输入手机号,回车确定',
  手机号格式错误: '手机号格式错误',
  手机号不能为空: '手机号不能为空',
  职位不能为空: '职位不能为空',
  职位: '职位',
  最多输入20个字符: '最多输入20个字符',
  头像: '头像',
  我的名片提示3: '1、建议尺寸1:1,不超过500kb',
  关闭: '关闭',
  推荐内容: '推荐内容',
  请完善名片: '请完善云展',
  请编辑您的个人简介: '请编辑您的个人简介',
  我的名片提示2: '空空如也,快去添加云展吧',
  个人云展预览: '个人云展预览',
  管理员名片: '管理员云展',
  我的名片提示1: '企业会员套餐需要企业主账号开通,子账号无权开通！请联系您的企业管理员进行续费或升级,您的企业管理员为',
  续费: '续费',
  未认证: '未认证',
  有效期至: '有效期至',
  个人云展预览效果: '个人云展预览效果',
  你的名片已被禁用: '你的云展已被禁用',
  原因: '原因',
  参观商我的名片提示建议1:
    '您还没有申请企业认证,暂时无法获取企业云展系统,客户看到您的云展附带的企业云展系统的内容都显示为空,为了获取更多客源订单,强烈建议',
  点击申请: '点击申请',
  '参观商我的名片提示建议1-1': '认证成为企业,并完善企业内容信息,也可以创建多个子账号给下属进行裂变获客！',
  名片: '云展',
  名片夹: '云展夹',
  '请输入公司名/姓名': '请输入公司名/姓名',
  // Ta转发了您的名片 1 次
  Ta转发了您的名片: 'Ta转发了您的云展',
  // Ta查看了您的名片 1 次
  Ta查看了您的名片: 'Ta查看了您的云展',
  '联系方式（二选一）': '联系方式（二选一）',
  修改名片: '修改云展',
  姓名: '姓名',
  手机号: '手机号',
  固定电话: '固定电话',
  个人简介: '个人简介',
  个人标签: '个人标签',
  联系人姓名不能为空: '联系人姓名不能为空',
  最多填写20位数字: '最多填写20位数字',
  分享二维码让客户扫一扫获取您的名片: '分享二维码让客户扫一扫获取您的云展',
  暂无名片夹数据: '暂无名片夹数据',
  '请填写,最多500字符,若需要换行,请直接回车键输入': '请填写,最多500字符,若需要换行,请直接回车键输入',
  '请填写,每个标签最多15个字符,最多20个标签,回车键确定': '请填写,每个标签最多15个字符,最多20个标签,回车键确定',
  形象照片: '形象照片',
  添加推荐: '添加推荐',
  我的推荐内容: '我的推荐内容',
  推荐内容类型: '推荐内容类型',
  暂无设置推荐内容: '暂无设置推荐内容',
  暂无填写个人简介: '暂无填写个人简介',
  暂无填写个人名片: '暂无填写个人云展',
  预览名片: '预览云展',
  分享云展: '分享云展',
  预览效果: '预览效果',
  选择推荐内容类型: '选择推荐内容类型',
  修改个人简介: '修改个人简介',
  确定: '确定',
  修改推荐内容成功: '修改推荐内容成功',
  请选择类型: '请选择类型',
  最多可推荐3个: '最多可推荐3个',
  '您的标签数已超20个,无法再添加': '您的标签数已超20个,无法再添加',
  个人标签最多输入15个字符: '个人标签最多输入15个字符',
}
